/**
 * Safely open a new window (and set opener to null due to XSS)
 * https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
 * @param url
 */
export const safelyOpenwindow = (url: string) => {
    window.open(url, '_blank', 'noopener noreferrer')
}
